import CustomManufacturingHeader from "./Header";
import "./index.css";
import { useState } from "react";
import MaterialUsage34_1a from "./MaterialUsage34_1a";
import PackagingUsage34_1b from "./PackagingUsage34_1b";
import WaterUsage34_1c from "./WaterUsage34_1c";
import ProductionMachines34_2a from "./ProductionMachines34_2a";
import ProductionVehicles34_2b from "./ProductionVehicles34_2b";
import SurplusResources34_3 from "./SurplusResources34_3";
import { ShowHide } from "../components/ShowHideProduct";
import { usePDFShowHide } from "../../../../hooks/usePDFShowHide";

const ProdCustomManufacturingComponents = ({ productId }) => {
  const [show, setShow] = usePDFShowHide(false, {
    forceShowInPDF: true,
    pdfDelay: 1000,
  });
  const [totalProdItem, setTotalProdItem] = useState([]);

  return (
    <div
      className="prod-custom-manufacturing-container"
      id="prod-custom-manufacturing-id"
    >
      <CustomManufacturingHeader
        productId={productId}
        show={show}
        totalProdItem={totalProdItem}
      />
      <ShowHide show={show} setShow={setShow} />
      {show && (
        <div className="prod-component-contents">
          <MaterialUsage34_1a productId={productId} />
          <PackagingUsage34_1b productId={productId} />
          <WaterUsage34_1c productId={productId} />
          <ProductionMachines34_2a productId={productId} />
          <ProductionVehicles34_2b productId={productId} />
          <SurplusResources34_3 productId={productId} />
        </div>
      )}
    </div>
  );
};

export default ProdCustomManufacturingComponents;
